// Lightweight analytics wrapper around GA4 gtag
// Tracks key user actions for understanding engagement

function gtag() {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag(...arguments);
  }
}

// Challenge events
export function trackChallengeGenerated(category) {
  gtag("event", "challenge_generated", {
    category_id: category?.id,
    category_label: category?.label,
  });
}

export function trackChallengeCompleted(category, streakCount) {
  gtag("event", "challenge_completed", {
    category_id: category?.id,
    category_label: category?.label,
    streak_count: streakCount,
  });
}

// Reflection events
export function trackReflectionWritten(hasAI) {
  gtag("event", "reflection_written", {
    has_ai_feedback: hasAI,
  });
}

// Navigation events
export function trackPageView(pageName) {
  gtag("event", "page_view", {
    page_title: pageName,
  });
}

// History style changed
export function trackHistoryStyleChanged(style) {
  gtag("event", "history_style_changed", {
    style,
  });
}

// Auth events
export function trackLogin() {
  gtag("event", "login", { method: "google" });
}

export function trackSignup() {
  gtag("event", "sign_up", { method: "google" });
}

// Feature usage
export function trackFeatureUsed(featureName) {
  gtag("event", "feature_used", {
    feature: featureName,
  });
}

// Engagement
export function trackReminderToggled(enabled) {
  gtag("event", "reminder_toggled", {
    enabled,
  });
}

export function trackDataExported() {
  gtag("event", "data_exported");
}

export function trackAchievementUnlocked(achievementId, achievementTitle) {
  gtag("event", "achievement_unlocked", {
    achievement_id: achievementId,
    achievement_title: achievementTitle,
  });
}
